import { useState } from 'react'
import { Button } from 'antd'

import { consentDecided, denyConsent, grantConsent } from '../utils/gtmBoot'

// Customer-facing path prefixes — the banner only shows there (never on admin),
// matching the host-gated GTM loader.
const CUSTOMER_PREFIXES = ['/portal', '/shop', '/pay', '/n/']

/**
 * Minimal cookie-consent banner. Google Consent Mode v2 already defaults to
 * "denied" (bootGtm), so GTM runs cookieless until the visitor accepts here.
 * Shown once, only on customer-facing pages, dismissed after a choice.
 */
export default function CookieConsent() {
  const [dismissed, setDismissed] = useState(() => consentDecided())

  const path = typeof window !== 'undefined' ? window.location.pathname : ''
  const onCustomerPage = path === '/' || CUSTOMER_PREFIXES.some((p) => path.startsWith(p))
  if (dismissed || !onCustomerPage) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie-Einwilligung"
      style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 2000,
        background: '#111827', color: '#f9fafb', padding: '12px 16px',
        display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap',
        justifyContent: 'center', boxShadow: '0 -2px 12px rgba(0,0,0,0.25)',
      }}
    >
      <span style={{ fontSize: 13, lineHeight: 1.4, maxWidth: 680 }}>
        Wir verwenden Cookies und Google-Dienste (Google Tag Manager), um unser
        Angebot zu verbessern. Mit „Akzeptieren" stimmst du optionalen Analyse- und
        Marketing-Cookies zu. Notwendige Funktionen bleiben immer aktiv.
      </span>
      <Button size="small" onClick={() => { denyConsent(); setDismissed(true) }}>
        Ablehnen
      </Button>
      <Button size="small" type="primary" onClick={() => { grantConsent(); setDismissed(true) }}>
        Akzeptieren
      </Button>
    </div>
  )
}
